import React, {Component} from 'react';
import PopupModal from '../../helpers/popupModal';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import myFetchWithId from '../../helpers/myFetch';
import { fetchMyDiffusion,setMyDiffusion } from '../../actions';
import { connect } from 'react-redux';
import * as Yup from 'yup';

const parms = [
  {name: '瀏覽數', apiName: 'bweight', initValue: 1},
  {name: '回文數', apiName: 'rweight', initValue: 1},
  {name: '按讚數', apiName: 'lweight', initValue: 1},
  {name: '分享數', apiName: 'sweight', initValue: 1}
];

const validationDiff = Yup.object().shape({
  bweight: Yup.number()
    .typeError('觸發值請填入數字')
    .positive('觸發值請大於零')
    .required('必填'),
  rweight: Yup.number()
    .typeError('觸發值請填入數字')
    .positive('觸發值請填大於零')
    .required('必填'),
  lweight: Yup.number()
    .typeError('觸發值請填入數字')
    .positive('觸發值請大於零')
    .required('必填'),
  sweight: Yup.number()
    .typeError('觸發值請填入數字')
    .positive('觸發值請大於零')
    .required('必填'),
})

const validationPassword = Yup.object().shape({
  old_password: Yup.string()
    .required('必填'),
  new_password: Yup.string()
    .required('必填')
})

const mapStateToProps = state => {
  return {
    initialValues: state.search.diffusionStting
  };
}
const mapDispatchToProps = dispatch => {
  return {
    fetchMyDiffusion: () => dispatch(fetchMyDiffusion()),
    setMyDiffusion:(diffusion)=>dispatch(setMyDiffusion(diffusion))
  };
};

class DiffSettingComponent extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.props.fetchMyDiffusion()
  }

  render() {
    const { cancel, initialValues, fetchMyDiffusion } = this.props;

    // fetchMyDiffusion();
    console.log(initialValues)

    return (
      <PopupModal
        header={'擴散度設定'}
        enableButton={false}
      >
        <Formik
          initialValues={{
            bweight: initialValues.b_weight ? initialValues.b_weight : 1,
            rweight: initialValues.r_weight ? initialValues.r_weight : 1,
            lweight: initialValues.l_weight ? initialValues.l_weight : 1,
            sweight: initialValues.s_weight ? initialValues.s_weight : 1,
          }}
          validationSchema={validationDiff}
          onSubmit={(values) => {
            if (values.bweight==='' || values.rweight==='' || values.lweight==='' || values.sweight==='') {
              return null;
            } else {
              console.log('values', values);

              try {
                this.props.setMyDiffusion(values).then( data =>{
                  cancel();
                })
              } catch (err) {
                  this.props.updateError(err);
                  cancel();
              }
            }
          }}
          render={({
            handleSubmit,
            values: { valName },
            errors,
            isValid
          }) => (
            <Form>
              <div className='content-sm'>
                {parms.map((obj, i) =>
                  <div className='set' key={i}>
                    <div className='label'>
                      {obj.name}
                    </div>
                    <Field name={obj.apiName}/>
                    {errors[obj.apiName] && <span className="error-message">{errors[obj.apiName]}</span>}
                  </div>
                )}
              </div>
              <div className='popup-modal-buttonset-text-center'>
                <button className="cancel" type="button" onClick={cancel}>
                  取消
                </button>
                <button className="apply" type="submit">
                  設定
                </button>
              </div>
            </Form>
          )}
        />
      </PopupModal>
    );
  }
}

export const DiffSetting = connect(mapStateToProps, mapDispatchToProps)(DiffSettingComponent);

export const ResetPassword = (props) => {
  const { userName, cancel } = props;
  return (
    <PopupModal
      header={'重置密碼'}
      enableButton={false}
    >
      <Formik
        initialValues={{
          old_password: '',
          new_password: ''
        }}
        validationSchema={validationPassword}
        onSubmit={(values) => {
          if (values.oldPassword==='' || values.newPassword==='') {
            return null;
          } else {
            const normalFetch = myFetchWithId('', true, true);
            // console.log('values', values);
            try {
              normalFetch(`/v5/lowi/profile/cpwd`, {...values})
              .then( data => {
                console.log(data);
                cancel();
              })
            } catch (err) {
                this.props.updateError(err);
                cancel();
            }
          }
        }}
        render={({
          handleSubmit,
          values: { valName },
          errors,
          isValid
        }) => (
          <Form>
            <div className='content-sm'>
              <div className='set-long'>
                <div className='label'>
                  請輸入目前的密碼
                </div>
                <Field name='old_password' type='password'/>
                {errors.old_password && <span className="error-message">{errors.old_password}</span>}
              </div>
              <div className='set-long'>
                <div className='label'>
                  請輸入新密碼
                </div>
                <Field name='new_password' type='password'/>
                {errors.new_password && <span className="error-message">{errors.new_password}</span>}
              </div>
            </div>
            <div className='popup-modal-buttonset-text-center'>
              <button className="cancel" type="button" onClick={cancel}>
                取消
              </button>
              <button className="apply" type="submit">
                設定
              </button>
            </div>
          </Form>
        )}
      />
    </PopupModal>
  );
}



// WEBPACK FOOTER //
// ./src/components/popup/userSetting.js